module.exports = {
  content: {
    welcome: "欢迎你",
    signOut: "退出登录",
    or: "或",
    hello: "你好，",
    please: "请先",
    announcement: "通知公告",
    none: "无",
    applySettle: "申请入驻",
    myOrder: "订单",
    shoppingCart: "购物车",
    checkCarts: "您需要登录才能查看",
    checkProducts: "登录后查看账户信息",
    joinCart: "您的购物车目前是空的",
    delete: "删除",
    viewAll: "查看购物车",
    mine: "账户",
    typesGoods: "商品种类",
    sold: "已售",
    address: "所在地",
    collect: "收藏",
    goods: "宝贝",
    shop: "店铺",
    search: "搜索",
    searchPlaceholder: "搜索手机、平板电脑、笔记本电脑等...",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/header.js